<style>
	.bar {
	  fill: steelblue;
	}

	.bar:hover {
	  fill: brown;
	}
</style>
<div #containerChart></div>